import { render } from "./MasterClasses.vue?vue&type=template&id=0a802ac5&scoped=true"
import script from "./MasterClasses.vue?vue&type=script&lang=js"
export * from "./MasterClasses.vue?vue&type=script&lang=js"

import "./MasterClasses.vue?vue&type=style&index=0&id=0a802ac5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a802ac5"]])

export default __exports__